import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { Minus, Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	isExpanded: boolean;
	onClick: () => void;
	fontSize?: number;
};

export const ExpandToggleButton: FC<Props> = ({
	isExpanded,
	onClick,
	fontSize = 14,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const Icon = isExpanded ? Minus : Plus;
	const iconSize = Math.round(fontSize * 1.4);

	return (
		<IconButton
			disableRipple
			onClick={onClick}
			sx={{ paddingLeft: 0, justifyContent: "start" }}
		>
			<Stack direction="row" alignItems="center" gap={0.8}>
				<Icon size={iconSize} color={theme.palette.primary.main} />
				<Typography
					fontSize={fontSize}
					fontWeight={600}
					color={theme.palette.primary.main}
				>
					{isExpanded ? t(Resources.Common.Hide) : t(Resources.Common.ShowMore)}
				</Typography>
			</Stack>
		</IconButton>
	);
};
